import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 80px 0 40px;
    position: relative;
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        top: 50px;
        right: 50%;
        transform: translateX(50%);
    }
    transition: 0.2s;
    @media screen and (max-width: 767px){
        padding: 80px 20px 40px;
    }
`
export const List = styled.ul`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
    }
`
export const Item  = styled.li`
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
    padding: 22px;
    width: calc(100% / 3);
    box-sizing: border-box;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`
export const Link = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    font-size: 20px;
    color: #00a0e7;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0;
`
export const Img = styled.img``
export const Text = styled.p`
    font-size: 17px;
    color: #666666;
    line-height: 1.66em;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        text-align: center;
    }
`